/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class DataColumnListEditor extends Common.GridEditorBase<DataColumn> {
        protected getColumnsKey() { return DataColumnListColumns.columnsKey; };
        protected getDialogType() { return DataColumnDialog; }

        protected getAddButtonCaption() {
            return "Add Column";
        }

        protected getButtons() {
            var buttons = super.getButtons();

            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].icon = 'fa-plus';

            buttons.push({
                title: 'Update Columns',
                cssClass: 'update-columns-button',
                icon: 'fa-refresh',
                onClick: () => this.updateColumns && this.updateColumns()
            });

            return buttons;
        }

        public updateColumns: () => void;

        public setValue(value: Data.DataColumn[], merge: boolean = true) {
            if (!merge) {
                this.value = value || [];
                return;
            }

            var oldByName: Q.Dictionary<Data.DataColumn> = {};
            for (var k of (this?.value || []))
                oldByName[k.Name] = k;

            this.value = (value || []).map(x => {
                var old = oldByName[x.Name];
                if (old) {
                    old.Type = x.Type;
                    old.Size = x.Size;
                    old.Scale = x.Scale;
                    return old;
                }
                return x;
            });
        }

        validateEntity(row, id) {
            return true;
        }
    }
}